module.exports = __webpack_public_path__ + "resources/video-play.673ab40d0ba42417.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-text/img/video-play.png
// module id = 632
// module chunks = 0 1 2 3